import type { FC, ReactNode } from 'react'

import { Glow } from '@/components/generals/glow'
import { Button } from '@/components/generals/button'
import { Reveal } from '@/components/generals/reveal'
import { AnimatedHeading } from '@/components/generals/animated-heading'
import { HEADING_MD } from '@/components/generals/section-heading'

export const Cta: FC = (): ReactNode => {
    return (
        <section
            id='cta'
            className='relative w-full px-6 pt-[120px] pb-[120px] md:px-8 lg:px-16 lg:pt-[160px] lg:pb-[160px]'
        >
            {/* Deliberately un-clipped: the bloom spills past this section and
                lights the top of the translucent footer, as the original does. */}
            <Glow variant='cta' />

            <div className='relative z-1 mx-auto w-full max-w-[1000px]'>
                <div className='flex flex-col items-center gap-6 rounded-3xl bg-surface-1/90 px-6 py-16 text-center ring-1 ring-white/8 backdrop-blur-[2px] sm:px-12 sm:py-20'>
                    <AnimatedHeading
                        segments={[
                            { text: 'Ready to scale your brand to' },
                            { text: 'new heights?', serif: true }
                        ]}
                        className={`${HEADING_MD} mx-auto max-w-[20ch]`}
                    />

                    <Reveal
                        y={16}
                        blur={8}
                        delay={0.12}
                        className='mx-auto max-w-[52ch] text-[clamp(1rem,1.2vw,1.125rem)] leading-[1.55] tracking-[-0.01em] text-white/56'
                    >
                        If you want to achieve ground-breaking growth with increased sales and profitability with paid ads, then you&rsquo;re in the right place.
                    </Reveal>

                    <Reveal
                        y={16}
                        blur={8}
                        delay={0.2}
                        className='mt-2'
                    >
                        <Button href='/contact'>
                            Book a call
                        </Button>
                    </Reveal>
                </div>
            </div>
        </section>
    )
}
